import { IsEmptyString } from "../../Components/GeneralFunctions.jsx"

export function EmbeddedDynamicsGetLastInsertedCallId() {
    return localStorage.getItem("embeddeddynamics_lastinsertedcallid")
}

export function EmbeddedDynamicsSetLastInsertedCallId(value) {
    localStorage.setItem("embeddeddynamics_lastinsertedcallid", value)
}

export function EmbeddedDynamicsGetLastInsertedDynamicsCallId() {
    return localStorage.getItem("embeddeddynamics_lastinserteddynamicscallid")
}

export function EmbeddedDynamicsSetLastInsertedDynamicsCallId(value) {
    localStorage.setItem("embeddeddynamics_lastinserteddynamicscallid", value)
}
                
export function EmbeddedDynamicsGetLastAutoOpenMatch() {
    return localStorage.getItem("embeddeddynamics_lastautoopenmatch")
}

export function EmbeddedDynamicsSetLastAutoOpenMatch(value) {
    localStorage.setItem("embeddeddynamics_lastautoopenmatch", value)
}

export function EmbeddedDynamicsGetLastAutoCreateMatch() {
    return localStorage.getItem("embeddeddynamics_lastautocreatematch")
}

export function EmbeddedDynamicsSetLastAutoCreateMatch(value) {
    localStorage.setItem("embeddeddynamics_lastautocreatematch", value)
}

//==> SETTINGS

export function EmbeddedDynamicsGetSettingAutoCreateCall() {
    return localStorage.getItem("embeddeddynamics_setting_autocreatecall")
}

export function EmbeddedDynamicsSetSettingAutoCreateCall(value) {
    localStorage.setItem("embeddeddynamics_setting_autocreatecall", value)
}

export function EmbeddedDynamicsGetSettingAutoOpenMatch() {
    return localStorage.getItem("embeddeddynamics_setting_autoopenmatch")
}

export function EmbeddedDynamicsSetSettingAutoOpenMatch(value) {
    localStorage.setItem("embeddeddynamics_setting_autoopenmatch", value)
}

export function EmbeddedDynamicsGetSettingAutoCreateMatch() {
    return localStorage.getItem("embeddeddynamics_setting_autocreatematch")
}

export function EmbeddedDynamicsSetSettingAutoCreateMatch(value) {
    localStorage.setItem("embeddeddynamics_setting_autocreatematch", value)
}

export function EmbeddedDynamicsGetSettingDefaultInboundCallSubject() {
    let Result = localStorage.getItem("embeddeddynamics_setting_defaultinboundcallsubject")
    if (IsEmptyString(Result))
    {
        Result = "Call from <number>"
    }
    return Result    
}

export function EmbeddedDynamicsSetSettingDefaultInboundCallSubject(value) {
    localStorage.setItem("embeddeddynamics_setting_defaultinboundcallsubject", value)
}

export function EmbeddedDynamicsGetSettingDefaultInboundCallPriority() {
    let Result = localStorage.getItem("embeddeddynamics_setting_defaultinboundcallpriority")
    if (IsEmptyString(Result))
    {
        Result = "0"
    }
    return Result    
}

export function EmbeddedDynamicsSetSettingDefaultInboundCallPriority(value) {
    localStorage.setItem("embeddeddynamics_setting_defaultinboundcallpriority", value)
}

export function EmbeddedDynamicsGetSettingDefaultInboundCallDescription() {
    let Result = localStorage.getItem("embeddeddynamics_setting_defaultinboundcalldescription")
    if (IsEmptyString(Result))
    {
        Result = ""
    }
    return Result    
}

export function EmbeddedDynamicsSetSettingDefaultInboundCallDescription(value) {
    localStorage.setItem("embeddeddynamics_setting_defaultinboundcalldescription", value)
}

export function EmbeddedDynamicsGetSettingDefaultOutboundCallSubject() {
    let Result = localStorage.getItem("embeddeddynamics_setting_defaultoutboundcallsubject")
    if (IsEmptyString(Result))
    {
        Result = "Call to <number>"
    }
    return Result    
}

export function EmbeddedDynamicsSetSettingDefaultOutboundCallSubject(value) {
    localStorage.setItem("embeddeddynamics_setting_defaultoutboundcallsubject", value)
}

export function EmbeddedDynamicsGetSettingDefaultOutboundCallPriority() {
    let Result = localStorage.getItem("embeddeddynamics_setting_defaultoutboundcallpriority")
    if (IsEmptyString(Result))
    {
        Result = "0"
    }
    return Result    
}

export function EmbeddedDynamicsSetSettingDefaultOutboundCallPriority(value) {
    localStorage.setItem("embeddeddynamics_setting_defaultoutboundcallpriority", value)
}

export function EmbeddedDynamicsGetSettingDefaultOutboundCallDescription() {
    let Result = localStorage.getItem("embeddeddynamics_setting_defaultoutboundcalldescription")
    if (IsEmptyString(Result))
    {
        Result = ""
    }
    return Result    
}

export function EmbeddedDynamicsSetSettingDefaultOutboundCallDescription(value) {
    localStorage.setItem("embeddeddynamics_setting_defaultoutboundcalldescription", value)
}